import ImageWithFallback from 'components/ImageWithFallback';
import PopupWithDimmedBackground from 'components/PopupWithDimmedBackground';
import RoundedButton from 'components/RoundedButton';
import { TWishlistPrize } from 'stores/UserStore';
import styles from './UnfavouritePrizeModal.module.css';

interface UnfavouritePrizeModalProps {
  unfavouritePrize: (prize: TWishlistPrize) => void;
  handleOnClose: () => void;
  prize: TWishlistPrize;
}

const UnfavouritePrizeModal = ({
  unfavouritePrize,
  handleOnClose,
  prize,
}: UnfavouritePrizeModalProps) => (
  <PopupWithDimmedBackground onClose={handleOnClose}>
    <div className={styles.container}>
      <div className="aboutUsTypographyHeaderMedium">Are you sure?</div>
      <div className={styles.prizeImage}>
        <ImageWithFallback
          src={prize.heroImageLocation}
          layout="fill"
          className={styles.image}
          alt={`Favourited prize image - ${prize.title}`}
        />
      </div>
      <div className={styles.prizeTitle}>
        Are you sure you want to remove <strong>{prize.title}</strong> from your
        Wishlist?
      </div>

      <div>
        <RoundedButton
          onClick={() => unfavouritePrize(prize)}
          colorStyle="OutlineDark"
          fullWidth={false}
          style={{ textTransform: 'none' }}
        >
          Remove from list
        </RoundedButton>
      </div>
    </div>
  </PopupWithDimmedBackground>
);

export default UnfavouritePrizeModal;
